




































































import { Component, Prop, Vue } from "vue-property-decorator";
import api from "../store/api";
import { IAccountDetails, IAssessment } from "../store/main.interfaces";
import AccountCreationForm from "../components/account-creation-form.vue";
import { TranslateResult } from "vue-i18n";
import { createEmptyUserObject } from "../store/user.util";
import user from "../store/modules/user";
import { i18n } from "../main";

@Component({
  components: { AccountCreationForm }
})
export default class SettingsView extends Vue {
  userObject: IAccountDetails | null = user.userData as IAccountDetails;
  selectedLanguage!: string;
  dialogText: string | TranslateResult = "";
  resultDialog: boolean = false;
  defaultLang: string = "en";
  privilegeRestriction: string = "NOT_ACCESSIBLE";
  data() {
    return {
      langs: [
        {
          name: "Deutsch",
          value: "de"
        },
        {
          name: "English",
          value: "en"
        }
      ]
    };
  }
  async editAccount(userObject: IAccountDetails) {
    if (
      userObject.username !== "" &&
      userObject.password !== "" &&
      userObject.organization !== "" &&
      userObject.email !== "" &&
      userObject.roles.length > 0
    ) {
      const editAccountResponse = await api.updateOwnAccount(userObject);
      if (editAccountResponse === false) {
        this.dialogText = this.$t("dialogs.updateAccount.onError") as string;
        this.resultDialog = true;
      } else {
        this.dialogText = this.$t("dialogs.updateAccount.onSuccess", {
          user: userObject.username
        });
        this.resultDialog = true;
        user.loginWithoutUsername();
      }
    } else {
      this.dialogText = this.$t("messages.fillAllFields");
      this.resultDialog = true;
    }
  }
}
